export const blockIconsNotificationDoNotDisturb = (
	<span className='material-symbols-outlined'>do_not_disturb</span>
);
